import { Pane } from '@folio/stripes/components';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Calendar from '../../components/Calendar';
import { getDateArray } from '../../utils/CalendarUtils';
import { dateUTCToYYYYMMDD } from '../../utils/DateUtils';
import { useLocaleWeekdays } from '../../utils/WeekdayUtils';
export var MonthlyCalendarView = function (_a) {
    var onClose = _a.onClose, servicePoint = _a.servicePoint, events = _a.events, requestEvents = _a.requestEvents;
    var _b = useState(new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1))), monthBasis = _b[0], setMonthBasis = _b[1]; // start at current date
    var intl = useIntl();
    var localeWeekdays = useLocaleWeekdays(intl);
    useEffect(function () {
        (function () {
            if (servicePoint === undefined) {
                return;
            }
            var dateArray = getDateArray(intl.locale, monthBasis);
            if (events === undefined) {
                requestEvents(dateArray[0], dateArray[dateArray.length - 1], servicePoint === null || servicePoint === void 0 ? void 0 : servicePoint.id);
                return;
            }
            var missingDates = dateArray.map(function (date) { return !(dateUTCToYYYYMMDD(date) in events); });
            var rangeStartIndex = missingDates.indexOf(true);
            // none missing
            if (rangeStartIndex === -1)
                return;
            requestEvents(dateArray[rangeStartIndex], dateArray[missingDates.lastIndexOf(true)], servicePoint === null || servicePoint === void 0 ? void 0 : servicePoint.id);
        })();
    }, [monthBasis, events, localeWeekdays, intl, servicePoint, requestEvents]);
    if (servicePoint === undefined) {
        return null;
    }
    return (React.createElement(Pane, { paneTitle: servicePoint.name, defaultWidth: "fill", centerContent: true, onClose: onClose, dismissible: true, lastMenu: React.createElement("div", { style: { width: '24px' } }) },
        React.createElement(Calendar, { events: events !== null && events !== void 0 ? events : {}, monthBasis: monthBasis, setMonthBasis: setMonthBasis })));
};
export default MonthlyCalendarView;
